import React from 'react'
import { Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'

import { formatAddressToExtended } from '../../../../utils'
import type { ShippingData } from '../../../../../../core/requests/checkout'

export type DeliveryPackageProps = {
  deliveryAddress: ShippingData['address'] | undefined
}

export const DeliveryPackage = ({ deliveryAddress }: DeliveryPackageProps) => {
  return (
    <>
      <Text variant="title1" tone="secondary">
        <FormattedMessage id="checkout.order-summary.products-for-delivery.address-title" />
      </Text>
      <Text variant="title1" aria-label="delivery-address">
        {formatAddressToExtended({
          city: deliveryAddress?.city,
          number: deliveryAddress?.number,
          postalCode: deliveryAddress?.postalCode ?? '',
          state: deliveryAddress?.state,
          street: deliveryAddress?.street,
          complement: deliveryAddress?.complement ?? '',
        })}
      </Text>
    </>
  )
}
